export const environment = {
  production: true,
  debounceTime: 150,
  lookerApiHost: 'https://analytics.kohort.io'
};
